// Shared UI chime — reused across the marble triad click, donation success,
// and prayer-request submission. Respects the localStorage sound preference
// (`ricc-sound` = "on" | "off"; default: on) set by the Navbar SoundToggle.
let _sharedCtx = null;

/**
 * Soft ~200 ms sine chime. `variant` tunes the frequency + envelope so the
 * three touchpoints feel related but distinct.
 *   "coin"    → 880→660 Hz  (marble triad tap)
 *   "success" → 660→990 Hz  (upbeat, for donations & prayer submits)
 *   "prayer"  → 523→659 Hz  (gentler, contemplative)
 */
export function playChime(variant = "coin") {
  try {
    if (typeof window === "undefined") return;
    if (window.localStorage?.getItem("ricc-sound") === "off") return;
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    if (!_sharedCtx) _sharedCtx = new AudioCtx();
    if (_sharedCtx.state === "suspended") _sharedCtx.resume();

    const now = _sharedCtx.currentTime;
    const [start, end, dur, peak] =
      variant === "success" ? [660, 990, 0.34, 0.16] :
      variant === "prayer"  ? [523, 659, 0.42, 0.12] :
                              [880, 660, 0.26, 0.14];

    const osc = _sharedCtx.createOscillator();
    const gain = _sharedCtx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(start, now);
    osc.frequency.exponentialRampToValueAtTime(end, now + dur * 0.7);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(peak, now + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + dur);
    osc.connect(gain).connect(_sharedCtx.destination);
    osc.start(now);
    osc.stop(now + dur + 0.02);
    // Release the graph nodes and park the context so it never keeps the audio
    // session (or memory) alive between chimes.
    osc.onended = () => {
      try { osc.disconnect(); gain.disconnect(); } catch { /* already gone */ }
      if (_sharedCtx && _sharedCtx.state === "running") _sharedCtx.suspend().catch(() => {});
    };
  } catch { /* decorative — fail silently */ }
}
